import { render, staticRenderFns } from "./FauxTabs.vue?vue&type=template&id=10272166"
import script from "./FauxTabs.vue?vue&type=script&lang=js"
export * from "./FauxTabs.vue?vue&type=script&lang=js"
import style0 from "./FauxTabs.vue?vue&type=style&index=0&id=10272166&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports